import { DataChart, DataGrid } from 'app/components'
import { Container, IAppState } from 'app/containers/Container'
import * as React from 'react'
import { Col, Modal, Panel, Row } from 'react-bootstrap'
import { AccountUsersDataSource, PersonalWagesDataSource } from './DataSources'

interface IDashboardState {
  showModal: boolean
}

class Dashboard extends React.Component<{}, IDashboardState> {
  state = {
    showModal: false
  }

  close(): void {
    this.setState({ showModal: false });
  }

  open(): void {
    this.setState({ showModal: true });
  }

  render() {
    return (
      <section>
        <header className="stripes-container">
          <div className="stripes">
            <div className="s1"></div>
          </div>

          <div className="header-margin" style={{ marginBottom: 0 }}>
            <div className="container">
              <div className="row">
                <div className="col-lg-4">
                  <ul className="breadcrumb">
                    <li className="animated fadeIn">
                      Dashboard
                    </li>
                  </ul>
                </div>
                <div className="col-lg-3 col-lg-offset-2 col-xs-6 animated fadeIn">
                  <button type="button" className="btn btn-primary btn-block header-margin-bottom" onClick={() => this.open()}>
                    <i className="fa fa-fw fa-filter"></i>
                    Filters
                  </button>
                </div>
                <div className="col-lg-3 col-xs-6 animated fadeIn">
                  <button type="button" className="btn btn-default btn-block header-margin-bottom" onClick={() => alert('filters reset')}>
                    <i className="fa fa-fw fa-times-circle"></i>
                    Reset Filters
                </button>
                </div>
              </div>
            </div>
          </div>
        </header>

        <section className="container margin-top-lg">
          <h6>Mock LocalDataSource DataGrid</h6>
          <DataGrid className="animated fadeIn"
            DataSource={PersonalWagesDataSource}
            pageSizes={[5, 10, 20]}
            columns={[
              { label: 'First Name', pathExpression: '$.firstName' },
              { label: 'Last Name', pathExpression: '$.lastName' },
              { label: 'Salary', pathExpression: '$.salary' },
            ]}
          />

          <Row>
            <Col sm={6}>
              <h6>Mock LocalDataSource Column DataChart</h6>
              <Panel className="animated fadeIn">
                <DataChart
                  config={{
                    chart: { type: 'column', height: 300 },
                    yAxis: { title: { text: 'Salary' } },
                    xAxis: { type: 'category' },
                  }}
                  series={[{
                    name: 'Salaries',
                    colorByPoint: true,
                    data: [
                      {
                        nameExpression: '$[i].firstName',
                        yExpression: '$[i].salary',
                        loop: true
                      },
                    ]
                  }]}
                />
              </Panel>
            </Col>

            <Col sm={6}>
              <h6>Mock LocalDataSource Line DataChart</h6>
              <Panel className="animated fadeIn">
                <DataChart
                  config={{
                    chart: { type: 'line', height: 300 },
                    yAxis: { title: { text: 'Salary' } },
                  }}
                  series={[{
                    name: 'Salaries',
                    dataExpression: '$..[salary]'
                  }]}
                />
              </Panel>
            </Col>

            <Col xs={12}>
              <h6>174.129.110.160 RemoteDataSource DataGrid</h6>
              <DataGrid DataSource={AccountUsersDataSource} className="animated fadeIn"
                pageSizes={[10, 15, 25]}
                columns={[
                  { label: 'Type', pathExpression: '$.activation_code.type' },
                  { label: 'Value', pathExpression: '$.activation_code.value' },
                ]}
              />
            </Col>
          </Row>
        </section>

        <Modal show={this.state.showModal} onHide={() => this.close()}>
          <Modal.Header closeButton onClick={() => this.close()}>
            {/* <Modal.Title>Filters</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <h4>List of filters here...</h4>
          </Modal.Body>
        </Modal>
      </section >
    )
  }
}

export {
  Dashboard
}



// WEBPACK FOOTER //
// ./src/app/containers/Dashboard/index.tsx